import { render } from "./BeneficiaryManagement.vue?vue&type=template&id=a573361a&scoped=true"
import script from "./BeneficiaryManagement.vue?vue&type=script&lang=js"
export * from "./BeneficiaryManagement.vue?vue&type=script&lang=js"

import "./BeneficiaryManagement.vue?vue&type=style&index=0&id=a573361a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a573361a"]])

export default __exports__